import homeIcon from 'assets/icons/homeIcon.svg';
import bdTrackerIcon from 'assets/icons/bdTrackerIcon.svg';
import databaseIcon from 'assets/icons/databaseIcon.svg';
import newProductIcon from 'assets/icons/newProductIcon.svg';
import bdtracker from 'assets/icons/bdtracker.svg';
import { CotTypesInterface } from 'Interfaces/FactsInterfaces/drugInterfaces';

export interface MenuItem {
  navbarHeading: string;
  screenName: string;
  icon?: string;
  route?: string;
  disabled?: boolean;
  featureFlag?: string;
  children?: MenuItem[];
}

export const screenHeadersData: MenuItem[] = [
  {
    navbarHeading: 'Home page navbar heading',
    screenName: 'Home',
    icon: homeIcon,
    route: '/',
    disabled: false,
  },
  {
    navbarHeading: 'Facts',
    screenName: 'Facts',
    icon: bdTrackerIcon,
    route: '/facts',
    disabled: false,
    children: [
      {
        navbarHeading: 'Active Drug Strategy Adjustments',
        screenName: 'Active Drug Strategy',
        route: '/facts/active_drug_strategy',
        disabled: false,
      },
      {
        navbarHeading: 'Drug Portfolio Management',
        screenName: 'Drug Portfolio Management',
        route: '/facts/drug_portfolio_management',
        disabled: false,
      },
      {
        navbarHeading: 'Drug Journey',
        screenName: 'Drug Journey',
        disabled: true,
      },
    ],
  },
  {
    navbarHeading: 'FDP',
    screenName: 'FDP',
    icon: databaseIcon,
    route: '/fdp',
    disabled: false,
    children: [
      {
        navbarHeading: 'Sales Plan',
        screenName: 'Sales Plan',
        route: '/fdp/target_market',
        disabled: false,
      },
      {
        navbarHeading: 'Unconstrained Forecast',
        screenName: 'Unconstrained Forecast',
        route: '/fdp/unconstrained_forecast',
        disabled: false,
      },
      {
        navbarHeading: 'Constrained Forecast',
        screenName: 'Constrained Forecast',
        route: '/fdp/constrained_forecast',
        disabled: false,
      },
      {
        navbarHeading: 'Supplier Forecast',
        screenName: 'Supplier Forecast',
        route: '/fdp/supplier_forecast',
        disabled: false,
      },
      {
        navbarHeading: 'Provisional Forecast',
        screenName: 'Provisional Forecast',
        route: '/fdp/provisonal_forecast',
        disabled: false,
      },
      {
        navbarHeading: 'Out of Cycle',
        screenName: 'Out of Cycle',
        route: '/fdp/ooc',
        disabled: false,
      },
    ],
  },
  {
    navbarHeading: 'BD Tracker',
    screenName: 'BD Tracker',
    icon: bdtracker,
    route: '/bdportal',
    disabled: false,
    children: [
      {
        navbarHeading: 'Opportunity Tracker',
        screenName: 'Opportunity Tracker',
        route: '/bdportal/optracker/board',
        disabled: false,
      },
      {
        navbarHeading: 'Product Wiki',
        screenName: 'Product Wiki',
        route: '/bdportal/product-wiki',
        disabled: false,
      },
      {
        navbarHeading: 'Bid Analysis',
        screenName: 'Bid Analysis',
        route: '/bdportal/bid-analysis',
        disabled: false,
        children: [
          {
            navbarHeading: 'Dashboard',
            screenName: 'Dashboard',
            route: '/bdportal/bid-analysis/dashboard',
            disabled: false,
          },
        ],
      },
    ],
  },
  // Hidden: Support Tickets - Use floating widget instead
  // {
  //   navbarHeading: 'Support Tickets',
  //   screenName: 'Support Tickets',
  //   icon: bdTrackerIcon,
  //   route: '/support-tickets',
  //   disabled: true,
  // },
  {
    navbarHeading: 'FDP Updated',
    screenName: 'FDP Updated',
    icon: databaseIcon,
    route: '/fdp-updated',
    disabled: false,
    featureFlag: 'mockups.storybook',
    children: [
      {
        navbarHeading: 'Sales Plan (15-Month)',
        screenName: 'Sales Plan (15-Month)',
        route: '/fdp-updated/sales_plan_updated',
        disabled: false,
      },
      {
        navbarHeading: 'Unconstrained Forecast (15-Month)',
        screenName: 'Unconstrained Forecast (15-Month)',
        route: '/fdp-updated/unconstrained_forecast',
        disabled: false,
      },
      {
        navbarHeading: 'Constrained Forecast (15-Month)',
        screenName: 'Constrained Forecast (15-Month)',
        route: '/fdp-updated/constrained_forecast',
        disabled: false,
      },
      {
        navbarHeading: 'Unconstrained Forecast Bulk Edit',
        screenName: 'Unconstrained Forecast Bulk Edit',
        route: '/fdp-updated/unconstrained_bulk_edit',
        disabled: false,
      },
      {
        navbarHeading: 'Sales Plan Bulk Edit',
        screenName: 'Sales Plan Bulk Edit',
        route: '/fdp-updated/sales_plan_bulk_edit',
        disabled: false,
      },
      {
        navbarHeading: 'Provisional Forecast',
        screenName: 'Provisional Forecast',
        route: '/fdp-updated/provisonal_forecast_updated',
        disabled: false,
      },
      {
        navbarHeading: 'Out of Cycle',
        screenName: 'Out of Cycle',
        route: '/fdp-updated/ooc',
        disabled: false,
      },
    ],
  },
  {
    navbarHeading: 'New Product Launch',
    screenName: 'New Product Launch',
    icon: newProductIcon,
    disabled: true,
  },
];

export const COTTypes: CotTypesInterface[] = ['MTF', 'VA Facility', 'CMOP', 'TMOP'];
